import { useFeatureIsOn } from '@growthbook/growthbook-react'
import React from 'react'
import { Drawer, Tabs, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { ExchangeRateComponent, RuleComponent } from './components'
import PropTypes from 'prop-types'

const EXCHANGE_RATE_KEY = 'exchangeRate'
const RULES_KEY = 'rules'

const ToolsDrawer = ({
  onRefetchDataTable = () => {},
  visible,
  onClose,
  periodId,
  hasRule = false,
  hasCurrency = false,
  globalProjectionId = null,
  type = '',
  onRefetchRules = () => {},
  applyRule = () => {},
  unApplyRule = () => {},
  disabledRule = false,
  typeModule = null,
  moduleId = null,
  isCurrencyLoading = false,
  currencyList = [],
  params = {},
  disabledDate = null,
  extraParams = {},
  disabledCurrency = false,
  setShowAlert = null,
  applyUnappluMassive = null,
  extraDataApplyUnapply = {},
  setApplyRuleB,
}) => {
  const enabled = useFeatureIsOn('feature-moneda-seguimiento')
  const { t } = useTranslation()

  return (
    <Drawer visible={visible} title={t('LABEL_TOOLS')} onClose={onClose} size="large">
      <Tabs defaultActiveKey={hasRule ? RULES_KEY : EXCHANGE_RATE_KEY} size="small">
        {hasRule && (
          <Tabs.TabPane
            tab={
              <Tooltip title={t('TAB_RULES_BUTTON_TOOLS_INFORMATIVE_TOOLTIP_TITLE')}>
                {t('LABEL_BUSINESS_RULES')}
              </Tooltip>
            }
            key={RULES_KEY}
          >
            <RuleComponent
              visible={visible}
              globalProjectionId={globalProjectionId}
              type={type}
              onRefetch={onRefetchDataTable}
              applyRule={applyRule}
              unApplyRule={unApplyRule}
              disabled={disabledRule}
              typeModule={typeModule}
              moduleId={moduleId}
              extraParams={extraParams}
              setShowAlert={setShowAlert}
              applyUnappluMassive={applyUnappluMassive}
              extraDataApplyUnapply={extraDataApplyUnapply}
              setApplyRuleB={setApplyRuleB}
            />
          </Tabs.TabPane>
        )}
        {enabled && hasCurrency && (
          <Tabs.TabPane
            tab={
              <Tooltip title={t('TAB_CURRENCY_BUTTON_TOOLS_INFORMATIVE_TOOLTIP_TITLE')}>
                {t('LABEL_EXCHANGE_RATE')}
              </Tooltip>
            }
            key={EXCHANGE_RATE_KEY}
            style={{ width: '100%' }}
          >
            <ExchangeRateComponent
              visible={visible}
              periodId={periodId}
              isCurrencyLoading={isCurrencyLoading}
              currencyList={currencyList}
              onRefetchDataTable={onRefetchDataTable}
              type={type}
              params={params}
              disabledDate={disabledDate}
              disabledCurrency={disabledCurrency}
              setShowAlert={setShowAlert}
            />
          </Tabs.TabPane>
        )}
      </Tabs>
    </Drawer>
  )
}

ToolsDrawer.propTypes = {
  onRefetchDataTable: PropTypes.func,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  periodId: PropTypes.any,
  hasRule: PropTypes.bool,
  hasCurrency: PropTypes.bool,
  globalProjectionId: PropTypes.any,
  type: PropTypes.any,
  onRefetchRules: PropTypes.func,
  applyRule: PropTypes.func,
  unApplyRule: PropTypes.func,
  disabledRule: PropTypes.bool,
  typeModule: PropTypes.string,
  moduleId: PropTypes.any,
  isCurrencyLoading: PropTypes.bool,
  currencyList: PropTypes.array,
  params: PropTypes.object,
  disabledDate: PropTypes.any,
  extraParams: PropTypes.object,
  disabledCurrency: PropTypes.bool,
  setShowAlert: PropTypes.func,
  applyUnappluMassive: PropTypes.func,
  extraDataApplyUnapply: PropTypes.object,
  setApplyRuleB: PropTypes.func,
}

export default ToolsDrawer
